import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { storage } from '../../common/utils/storage';
import { routes } from '../../common/utils/routes';

interface OptionalAuthRouteProps {
  element: JSX.Element;
  requireAuth?: boolean;  // 특정 액션에 인증 필요 여부
}

/**
 * OptionalAuthRoute - 읽기는 가능하지만, 쓰기는 로그인 필요
 * Context를 통해 하위 컴포넌트에서 인증 상태 확인 및 로그인 유도 가능
 */
const OptionalAuthRoute: React.FC<OptionalAuthRouteProps> = ({ 
  element, 
  requireAuth = false 
}) => {
  const navigate = useNavigate();
  const isAuthenticated = !!storage.getToken();

  // Context로 인증 상태 제공
  const contextValue = React.useMemo(() => ({
    isAuthenticated,
    requireLogin: (redirectPath?: string) => {
      if (!isAuthenticated) {
        // 로그인 페이지로 이동하며 현재 경로 저장
        const currentPath = redirectPath || window.location.pathname;
        navigate(`${routes.LOGIN}?redirect=${encodeURIComponent(currentPath)}`);
      }
    }
  }), [isAuthenticated, navigate]);

  return (
    <AuthContext.Provider value={contextValue}>
      {element}
    </AuthContext.Provider>
  );
};

// Context 정의
export const AuthContext = React.createContext<{
  isAuthenticated: boolean;
  requireLogin: (redirectPath?: string) => void;
}>({
  isAuthenticated: false,
  requireLogin: () => {},
});

// Hook for easy access
export const useAuth = () => React.useContext(AuthContext);

export default OptionalAuthRoute;

